<template>
    <div>
        <div class="header">
            <router-link :to="{path:'/index'}" class="logo"></router-link>
            <!-- <div class="logo" ></div> -->
            <div class="nav pc">
                <router-link :to="{path:'/index'}" class="li" :class="path=='/index'?'on':''">首页</router-link>
                <router-link :to="{path:'/lease'}" class="li" :class="path=='/lease'?'on':''">房产租赁</router-link>
                <router-link :to="{path:'/business'}" class="li" :class="path=='/business'?'on':''">房产买卖</router-link>
                <router-link :to="{path:'/entrust'}" class="li" :class="path=='/entrust'?'on':''">委托管理</router-link>
                <router-link :to="{path:'/renovation'}" class="li" :class="path=='/renovation'?'on':''">装修业务</router-link>
                <router-link :to="{path:'/move'}" class="li" :class="path=='/move'?'on':''">搬家业务</router-link>
                <router-link :to="{path:'/news'}" class="li" :class="path=='/news'?'on':''">新闻中心</router-link>
                <router-link :to="{path:'/recruit'}" class="li" :class="path=='/recruit'?'on':''">招聘中心</router-link>
                <router-link :to="{path:'/about'}" class="li" :class="path=='/about'?'on':''">关于我们</router-link>
            </div>
            <div class="nav_jian" @click="wap_nav=!wap_nav" :class="wap_nav?'on':''"></div>
        </div>
        <div class="wap_nav" v-if="wap_nav">
            <router-link :to="{path:'/index'}" class="li"><div class="p1">首页</div></router-link>
            <div class="li" :class="index_on=='1'?'on':''">
                <div class="p1 pp1" @click="index_on=(index_on==1?0:1)">主要业务</div>
                <transition>
                    <div class="ul" v-show="index_on==1">
                        <router-link :to="{path:'/lease'}" class="p1" >房产租赁</router-link>
                        <router-link :to="{path:'/business'}" class="p1" :class="path=='/business'?'on':''">房产买卖</router-link>
                        <router-link :to="{path:'/entrust'}" class="p1" :class="path=='/entrust'?'on':''">委托管理</router-link>
                    </div>
                </transition>
            </div>
            <div class="li" :class="index_on=='2'?'on':''">
                <div class="p1  pp1" @click="index_on=(index_on==2?0:2)">其他业务</div>
                <transition>
                    <div class="ul" v-show="index_on==2">
                        <router-link :to="{path:'/renovation'}" class="p1" :class="path=='/renovation'?'on':''">装修业务</router-link>
                        <router-link :to="{path:'/move'}" class="p1" :class="path=='/move'?'on':''">搬家业务</router-link>
                    </div>
                </transition>
            </div>
            <router-link :to="{path:'/news'}" class="li" :class="path=='/news'?'on':''"><div class="p1">新闻中心</div></router-link>
            <router-link :to="{path:'/recruit'}" class="li" :class="path=='/recruit'?'on':''"><div class="p1">招聘中心</div></router-link>
            <router-link :to="{path:'/about'}" class="li" :class="path=='/about'?'on':''"><div class="p1">关于我们</div></router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'header_html',
    data () {
        return {
            index_on:0,
            wap_nav:false,
            path:this.$route.path,
        }
    },
    // 初始事件
    mounted: function () {
        // console.log(this.$route);
    },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header_html.vue